// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const InspectionIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M20.13 4.42c-.78-.78-7-2.92-8.13-2.92S4.65 3.63 3.87 4.42c-.62.62-.61 1.1-.56 3.75.02 1.08.04 2.54.04 4.57 0 7.08 8.4 9.71 8.49 9.74l.16.02.16-.02c.08-.03 8.49-2.66 8.49-9.74 0-2.02.02-3.48.04-4.56.05-2.66.06-3.14-.56-3.76"
        opacity=".5"
      />
      <path d="M15.7 15.37q-.26.24-.6.24-.32 0-.58-.24l-1.1-1.1c-.62.37-1.34.6-2.12.6-2.22 0-4.04-1.82-4.04-4.05s1.82-4.05 4.04-4.05c2.23 0 4.05 1.82 4.05 4.05 0 .85-.27 1.65-.73 2.3l1.08 1.08q.24.25.24.58 0 .34-.24.59m-6.78-4.55c0-1.32 1.07-2.39 2.38-2.39 1.32 0 2.39 1.07 2.39 2.39 0 .68-.29 1.29-.74 1.73q-.03 0-.04.04-.67.59-1.6.61c-1.32 0-2.39-1.07-2.39-2.38" />
    </g>
  </SvgIcon>
);

export default InspectionIcon;
